import { Button } from "@/components/ui/button";

export const WhyNoSignalCard = ({
  scannerState = "idle",
  selectionEmpty = false,
  selectedSymbolCount = 0,
  hardBlocks = [],
  softSkips = [],
  hasSignals = false,
  onGoSignals,
  onEditScope,
  onRelaxFilters,
}) => {
  const normalizedState = String(scannerState || "").trim().toLowerCase();
  const showSelectionEmpty = Boolean(selectionEmpty) || normalizedState === "selection_empty";
  const effectiveHardBlocks = showSelectionEmpty
    ? [{ code: "SELECTION_EMPTY", hint: `Aktif seçim yok (selected_symbol_count=${Number(selectedSymbolCount || 0)}).` }]
    : (Array.isArray(hardBlocks) ? hardBlocks : []);

  return (
    <section className="rounded-2xl border border-slate-200 bg-white p-5" data-testid="why-no-signal-card">
      <h3 className="text-base font-semibold text-slate-900" data-testid="why-no-signal-title">Why No Signal?</h3>
      <div className="mt-3 grid gap-3 lg:grid-cols-2" data-testid="why-no-signal-reason-grid">
        <article className="rounded-xl border border-rose-200 bg-rose-50 p-3" data-testid="why-no-signal-hard-blocks">
          <p className="text-xs font-semibold uppercase tracking-wider text-rose-700" data-testid="why-no-signal-hard-blocks-title">Hard Block Reasons</p>
          {effectiveHardBlocks.length === 0 ? (
            <p className="mt-2 text-sm text-rose-700" data-testid="why-no-signal-hard-blocks-empty">Aktif hard block yok</p>
          ) : (
            <ul className="mt-2 space-y-2" data-testid="why-no-signal-hard-blocks-list">
              {effectiveHardBlocks.map((item, index) => (
                <li key={`${item.reason_code || item.code || "hard"}-${index}`} className="rounded border border-rose-200 bg-white p-2" data-testid={`why-no-signal-hard-block-item-${index}`}>
                  <p className="text-sm font-semibold text-rose-800" data-testid={`why-no-signal-hard-block-code-${index}`}>{item.reason_code || item.code || "BLOCK"}</p>
                  <p className="text-xs text-rose-700" data-testid={`why-no-signal-hard-block-hint-${index}`}>{item.hint || item.message || "-"}</p>
                </li>
              ))}
            </ul>
          )}
        </article>

        <article className="rounded-xl border border-amber-200 bg-amber-50 p-3" data-testid="why-no-signal-soft-skips">
          <p className="text-xs font-semibold uppercase tracking-wider text-amber-700" data-testid="why-no-signal-soft-skips-title">Soft Skip Reasons</p>
          {softSkips.length === 0 ? (
            <p className="mt-2 text-sm text-amber-700" data-testid="why-no-signal-soft-skips-empty">Soft skip yok</p>
          ) : (
            <ul className="mt-2 space-y-2" data-testid="why-no-signal-soft-skips-list">
              {softSkips.map((item, index) => (
                <li key={`${item.reason_code || "soft"}-${index}`} className="rounded border border-amber-200 bg-white p-2" data-testid={`why-no-signal-soft-skip-item-${index}`}>
                  <p className="text-sm font-semibold text-amber-800" data-testid={`why-no-signal-soft-skip-code-${index}`}>{item.reason_code || "SOFT_SKIP"}</p>
                  <p className="text-xs text-amber-700" data-testid={`why-no-signal-soft-skip-hint-${index}`}>{item.hint || "-"}</p>
                </li>
              ))}
            </ul>
          )}
        </article>
      </div>

      <div className="mt-4 flex flex-wrap gap-2" data-testid="why-no-signal-cta-row">
        <Button type="button" variant="outline" onClick={onGoSignals} disabled={!hasSignals} data-testid="why-no-signal-go-signals-button">Sinyallere Git</Button>
        <Button type="button" variant="outline" onClick={onEditScope} data-testid="why-no-signal-edit-scope-button">Scope Düzenle</Button>
        <Button type="button" variant="outline" onClick={onRelaxFilters} data-testid="why-no-signal-relax-filters-button">Filtreleri Gevşet</Button>
      </div>
    </section>
  );
};
